import { PanelHeader } from '@vkontakte/vkui';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Шапка экрана.
 *
 * Каркас остаётся вкуишным — safe-area инсеты, место под кнопки ВК, повадки
 * iOS и Android. Своя здесь одна вещь — черта под шапкой, и она своя по двум
 * причинам сразу.
 *
 * Первая: у платформы черта отбита по бокам вкладышем из
 * `--vkui--size_base_padding_horizontal--regular` — того самого токена, что мы
 * приравняли к шестнадцати, — а в макетах она идёт ОТ КРАЯ ДО КРАЯ.
 *
 * Вторая, и она важнее: **вкуишная черта НЕ едет с шапкой**. Шапка
 * прикреплена (`FixedLayout` внутри), а `<Separator>` платформа рисует
 * СОСЕДОМ после прикреплённого блока, в обычном потоке — проверено замером:
 * при прокрутке на 300 шапка стоит на нуле, а черта уезжает на −244. Проп,
 * который перенёс бы её внутрь, у `PanelHeader` отсутствует: `delimiter`
 * только включает и выключает, а `float` — выключает совсем.
 *
 * Поэтому черту гасим (`delimiter="none"`) и рисуем сами на прикреплённом
 * блоке. Это единственное место в проекте, где мы дотягиваемся до вкуишного
 * класса, и берём мы стабильный литерал `vkuiInternalPanelHeader__fixed` —
 * VKUI ставит его рядом со своим хешируемым именно как точку опоры. Тенью
 * внутрь, а не рамкой: рамка съела бы пиксел высоты шапки.
 */
export function ScreenHeader({ before, children }: { before?: ReactNode; children: ReactNode }) {
  return (
    <PanelHeader className={styles.screenHeader} delimiter="none" before={before}>
      {children}
    </PanelHeader>
  );
}
